import React from "react";
import {
  formatRFC3339,
  startOfDay,
  endOfDay,
  isValid,
  startOfYear,
  endOfYear
} from "date-fns";

import ExportPanel from "./ExportPanel";
import config from "../../../config";
import { useDevice } from "../../../domain/device";
import { useLocale } from "../../../i18n";

// map each export with the backend export_type and set file format
const EXPORT_TYPES = {
  consumption: { exportType: "simple_consumption", fileFormat: "csv" },
  measurement: { exportType: "extended_consumption", fileFormat: "xlsx" }
};

const ExportButtonContainer = ({ currentView }) => {
  const { device } = useDevice();
  const { locale } = useLocale();

  const formatAndEncode = (date, adjustFn) => {
    return encodeURIComponent(formatRFC3339(adjustFn(date)));
  };

  const handleExport = ({ source, format, range }) => {
    const mapping = EXPORT_TYPES[source];

    let query =
      `export_type=${mapping.exportType}` +
      `&file_format=${format || mapping.fileFormat}` +
      `&device_id=${device.id}`;

    if (locale) {
      query += `&locale=${locale}`;
    }

    if (range.type === "custom") {
      if (isValid(range.from)) {
        query += `&from=${formatAndEncode(range.from, startOfDay)}`;
      }
      if (isValid(range.to)) {
        query += `&to=${formatAndEncode(range.to, endOfDay)}`;
      }
    } else {
      // show current year data, from the start of the year
      // to the end of the requested day
      const now = new Date();
      const fromVal = formatAndEncode(now, startOfYear);
      const toVal = formatAndEncode(now, endOfDay);

      query += `&from=${fromVal}&to=${toVal}`;
    }
    window.location.href = `${config.api.baseUrl}/v2/devices/export/?${query}`;
  };

  return <ExportPanel currentView={currentView} onExport={handleExport} />;
};

export default ExportButtonContainer;
